'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Examples = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _CodeExampleGenerator = require('../../utility/CodeExampleGenerator');

var _CodeExampleGenerator2 = _interopRequireDefault(_CodeExampleGenerator);

var _ExampleRequest = require('./ExampleRequest');

var _ExampleRequest2 = _interopRequireDefault(_ExampleRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var exampleComponents = {
	curl: {
		title: 'Curl',
		component: 'CodeExampleCurl',
		comment: 'This is an example you can run from command line using curl'
	},
	node: {
		title: 'Node.js',
		component: 'CodeExampleNodeJS',
		comment: 'This is an example you can use in your Node.js app'
	},
	titanium: {
		title: 'Titanium',
		component: 'CodeExampleTitanium',
		comment: 'This is an example you can use in your Titanium app'
	},
	web: {
		title: 'Web',
		component: 'CodeExampleWebJS',
		comment: 'This is an example you can use in your web app'
	}
};

/**
 * A plugin to replace the example "curl".
 * @param {object} Original - The original component
 * @param {object} system - The swagger-ui system
 * @return {function} A function to render the Examples component.
 */

var _default = function _default(Original, system) {
	var getComponent = system.getComponent,
	    getConfigs = system.getConfigs;


	return function (props) {
		var request = props.request;

		var _getConfigs = getConfigs(),
		    examples = _getConfigs.examples;

		if (!examples || !examples.length) {
			return null;
		}

		return _react2.default.createElement(Examples, {
			getComponent: getComponent,
			examples: examples,
			request: request
		});
	};
};

exports.default = _default;

/**
 * An Examples component to replace the "curl" component.
 * @param {function} getComponent - The swagger-ui function to get components.
 * @param {string[]} examples - The `examples` configuration
 * @param {object} request - A request object having properties: method, url,
 *	headers, and body
 * @return {object} Returns the Examples component.
 */

var Examples = exports.Examples = function Examples(_ref) {
	var getComponent = _ref.getComponent,
	    examples = _ref.examples,
	    request = _ref.request;

	if (!examples || !examples.length) {
		return null;
	}
	var exampleRequest = _ExampleRequest2.default.from(request);
	var generator = _CodeExampleGenerator2.default.from(exampleRequest);
	var tabs = [];
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = examples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var name = _step.value;

			var title = '';
			var code = '';
			var CodeExample = void 0;
			if (typeof name === 'string') {
				// a built-in example
				var exampleComponent = exampleComponents[name];
				if (!exampleComponent) {
					console.error('Unknown built-in code example: ' + name);
					return null;
				}
				CodeExample = getComponent(exampleComponent.component);
				code = generator.generate(name, exampleComponent.comment);
				title = exampleComponent.title;
			} else {
				// a custom example (`name` is an object)
				var _exampleComponent = name;
				if (!_exampleComponent.title) {
					console.error('Your code example requires a "title"');
					return null;
				}
				if (!_exampleComponent.generate) {
					console.error('Your code example requires a "generate" function');
					return null;
				}
				if (!_exampleComponent.component) {
					console.error('Your code example requires a "component" plugin name');
					return null;
				}
				CodeExample = getComponent(_exampleComponent.component);
				if (!CodeExample) {
					console.error('The code example plugin "' + _exampleComponent.component + '" is not registered');
					return null;
				}
				code = _exampleComponent.generate(exampleRequest);
				title = _exampleComponent.title;
			}
			if (examples.length === 1) {
				return _react2.default.createElement(CodeExample, { code: code });
			}

			tabs.push(_react2.default.createElement(
				_reactBootstrap.Tab,
				{
					eventKey: tabs.length + 1 + '',
					key: 'example-' + name,
					title: title
				},
				_react2.default.createElement(CodeExample, { code: code })
			));
		}

		// FIXME: is there a way to get rid of IntlProvider
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: 'en' },
		_react2.default.createElement(
			_reactBootstrap.Tabs,
			{
				animation: false,
				className: 'axui',
				id: 'axui-live-response-' + exampleRequest.method + '-' + exampleRequest.url
			},
			tabs
		)
	);
};

Examples.propTypes = {
	/**
  * The swagger-ui getComponent function.
  */
	getComponent: _propTypes2.default.func.isRequired,
	/**
  * Array of examples by key name.  The built in names are: curl, node, web,
  * and titanium.  Custom examples can be provided by included an object as
  * per the shape below.
  */
	examples: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
		component: _propTypes2.default.string.isRequired,
		comment: _propTypes2.default.string.isRequired,
		title: _propTypes2.default.string.isRequired,
		generate: _propTypes2.default.func.isRequired
	})])),
	/**
  *
  */
	request: _propTypes2.default.object.isRequired
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(exampleComponents, 'exampleComponents', 'src/components/OpenAPI/Examples.jsx');

	__REACT_HOT_LOADER__.register(Examples, 'Examples', 'src/components/OpenAPI/Examples.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/OpenAPI/Examples.jsx');
}();

;